import React from 'react';
import styled from '@emotion/styled';
import {Link} from "react-router-dom";
import PropTypes from 'prop-types';

const Container = styled.div`
    margin: 4px 0;
    padding: 4px 18px;
    font-size: 14px;
    color: ${props => props.theme.gray800};
    &:hover {
        background: ${props => props.theme.gray100};
        color: ${props => props.theme.highlight};
    }
`;

const HoverMenuItem = ({cy, children, ...restProps}) => {
    const Wrapper = restProps.to ? Link : 'a';
    return (
        <Wrapper {...restProps}>
            <Container data-cy={cy}>{children}</Container>
        </Wrapper>
    )
};

HoverMenuItem.propTypes = {
    to: PropTypes.string,
    cy: PropTypes.string
};

export default HoverMenuItem;
